/** Which size of the heavy image assets this device loads: "sm" for phones
 *  (1024-wide carousel strip, small case-study heroes and posters), "lg"
 *  otherwise. Decided once by the inline script at the top of index.html,
 *  so its preload hints and the runtime URLs always agree. */
export type AssetTier = "sm" | "lg";

export const ASSET_TIER: AssetTier =
    (window as Window & { __ASSET_TIER?: AssetTier }).__ASSET_TIER === "sm" ? "sm" : "lg";
